module.exports = __webpack_public_path__ + "static/media/booking.55d7adb9.png";